import { Series } from '../../model/series';
import { SeriesSimpleLinePaneView } from './series-simple-line-pane-view';
import { CustomSimpleLine } from '../../model/custom-simple-line';


export class CustomSimpleLinePaneView extends SeriesSimpleLinePaneView {
	private readonly _priceLine: CustomSimpleLine;

	public constructor(series: Series, priceLine: CustomSimpleLine) {
		super(series);
		this._priceLine = priceLine;
	}

	protected _updateImpl(height: number, width: number): void {
		const data = this._lineRendererData;
		data.visible = false;

		const y1 = this._priceLine.yCoord();
		const y2 = this._priceLine.yCoord2();
		
		if (y1 === null) return;
		
		const x1 = this._priceLine.xCoord1();
		const x2 = this._priceLine.xCoord2();

		const lineOptions = this._priceLine.options();

		data.visible = true;
		data.x1 = x1;
		data.y1 = y1;
		data.x2 = x2;
		data.y2 = y2;
		data.color = lineOptions.color;
		data.width = width;
		data.height = height;
		data.lineWidth = lineOptions.lineWidth;
		data.lineStyle = lineOptions.lineStyle;
		data.extended  = lineOptions.extended;	
	}
}
